const state = {
  token: window.localStorage.getItem("SAtoken"),
  success: true,
  error: null,
  applicationsVersions: [],
  expirationTime: 0,
  refreshExpirationTime: 0,
  needRefreshToken: false,
  loggedAdmin: null,
};

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  LOGIN_ERROR(state, error) {
    state.error = error;
  },
  LOGIN_SUCCESS(state, success) {
    state.success = success;
  },
  SET_APPLICATIONS_VERSIONS(state, applicationsVersions) {
    state.applicationsVersions = applicationsVersions;
  },
  SET_EXPIRATION_TIME(state, expirationTime) {
    (state.expirationTime = expirationTime),
      (state.refreshExpirationTime =
        window.localStorage.getItem("expTimeRefresh") - 3600);
  },
  SET_NEED_REFRESH_TOKEN(state, payload) {
    state.needRefreshToken = payload.decision;
  },
  SET_LOGGED_ADMIN(state, user) {
    state.loggedAdmin = user;
  },
};

const getters = {
  getToken: (state) => {
    return state.token;
  },
  getLoginSuccess: (state) => {
    return state.success;
  },
  getLoginError: (state) => {
    return state.error;
  },
  getApplicationsVersions: (state) => {
    return state.applicationsVersions;
  },
  getExpirationTime: (state) => {
    return state.expirationTime;
  },
  getRefreshExpirationTime: (state) => {
    return state.refreshExpirationTime;
  },
  getNeedRefreshToken: (state) => {
    return state.needRefreshToken;
  },
  getLoggedAdmin: () => {
    let adminFromLocalStorage = JSON.parse(
      window.localStorage.getItem("loggedAdmin")
    );
    if (!adminFromLocalStorage) {
      adminFromLocalStorage = state.loggedAdmin;
    }
    return adminFromLocalStorage;
  },
};

export default {
  state,
  mutations,
  getters,
};
